<template>
  <div class="FeatureScreening">
    <div class="titleDiv">
      <div class="title">
        <span>特性筛选</span>
      </div>
    </div>
    <a-row class="generalParameter">
      <a-col :span="8" v-for="(item, index) in featureList">
        <a-form-item :labelCol="labelColAll" :wrapperCol="wrapperColAll">
          <a-tree-select
            show-search
            :filterTreeNode="filterTreeNode"
            style="width: 100%"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            placeholder="请选择特性"
            allow-clear
            tree-default-expand-all
            :treeData="featureTreeList"
            v-model="item.featureId"
            :disabled="item.disabled"
            :replaceFields="{
              title: 'name',
              key: 'key',
              value: 'id'
            }"
            @change="(value, label, extra) => changeFeatureTree(value, label, extra, item, index)"
          ></a-tree-select>
          <a-icon type="close-square" theme="filled" class="delIcon" @click="delFeature(item, index)"/>
        </a-form-item>
      </a-col>
      <a-col :span="8">
        <a-form-item :label-col="labelColAll" :wrapper-col="wrapperColAll">
          <a-button block type="dashed" icon="plus" @click="addFeature" class="addBtn_general">添加</a-button>
        </a-form-item>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { getEquipmentTree } from '@/api/featureManagement'

export default {
  name: 'FeatureScreening',
  data () {
    return {
      labelColAll: {
        xs: { span: 24 },
        sm: { span: 0 }
      },
      wrapperColAll: {
        xs: { span: 24 },
        sm: { span: 24 }
      },
      // 特性筛选列表
      featureList: [],
      // 特性树列表
      featureTreeList: []
    }
  },
  created () {
    this.getFeatureList()
  },
  methods: {
    // 获取特性筛选列表
    getFeatureList () {
      getEquipmentTree().then(res => {
        if (res.status === 0) {
          this.featureTreeList = res.data
        } else {
          this.$message.error(res.info.message)
        }
      })
        .catch(err => {
          this.$message.error(err.info.message)
        })
    },
    // 树搜索
    filterTreeNode (inputValue, treeNode) {
      // return treeNode.componentOptions.propsData.dataRef.name.indexOf() > -1
      return treeNode.data.props.title.includes(inputValue)
    },
    // 给已选择的特性添加disabled
    findChildren (data, idList) {
      data.forEach(item => {
        item.disabled = idList.includes(item.id)
        if (item.children) {
          this.findChildren(item.children, idList)
        }
      })
    },
    // 树选择
    changeFeatureTree (value, label, extra, item, index) {
      const idList = []
      this.featureList.forEach(item => {
        idList.push(item.featureId)
      })
      this.findChildren(this.featureTreeList, idList)
    },
    // 删除
    delFeature (item, index) {
      this.featureList.splice(index, 1)
      const idList = []
      this.featureList.forEach(item => {
        idList.push(item.featureId)
      })
      this.findChildren(this.featureTreeList, idList)
    },
    // 添加
    addFeature () {
      this.featureList.push({
        featureId: ''
      })
    },
    // 重置参数
    reset () {
      this.featureList = []
      this.findChildren(this.featureTreeList, [])
    },
    // 获取查询参数，并返回给父组件
    getParamQuery () {
      const featureIdList = []
      try {
        this.featureList.forEach(item => {
          if (item.featureId) {
            featureIdList.push(item.featureId)
          } else {
            throw new Error('请选择特性')
          }
        })
      } catch (err) {
        this.$message.error(err.message)
        return false
      }
      return featureIdList
    }
  }
}
</script>

<style lang="less" scoped>
.FeatureScreening {
  margin-top: 20px;
}
.titleDiv {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  .title span{
    border-left: 4px solid #08409F;
    padding-left: 8px;
    color: rgba(8, 64, 159, 1);
  }
}
.generalParameter {
  /deep/.ant-col-8 {
    padding-right: 12px;
    .ant-form-item-children {
      display: flex;
      flex-direction: row;
      align-items: center;
      .ant-select {
        width: calc(100% - 28px);
        margin-right: 8px;
      }
      .delIcon {
        font-size: 20px;
        color: red;
      }
    }
  }
}
</style>
